import { Injectable } from '@angular/core';
import {IPlayer} from '@api/models/player/player';
import {PlayersHttpService} from '@api/http/players/players-http.service';
import {MatchService} from '../match/match.service';

@Injectable({
  providedIn: 'root'
})
export class MatchPlayersService {

  public players: Partial<IPlayer>[] = [];

  constructor( private matchService: MatchService,
               private playersHttpService: PlayersHttpService ) { }

  public async getPlayer(playerId: string): Promise<IPlayer | null> {
    if (!playerId) {
      return null;
    }
    let player = this.players.find((p) => p._id === playerId);
    if (player) {
      return player as IPlayer;
    }
    player = await this.playersHttpService.getPlayer(playerId);
    if (!player.playername) {
      player.playername = `${player.firstname} ${player.lastname}`;
    }
    this.players.push(player);
    return player as IPlayer;
  }

  public setPlayer(player: Partial<IPlayer>): void {
    const existing = this.players.find((p) => p._id === player._id);
    if (!existing) {
      if (!player.playername) {
        player.playername = `${player.firstname} ${player.lastname}`;
      }
      this.players.push(player);
    }
  }
}
